import { Stack } from '@mui/material';
import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import { useSettingValue } from 'app/profile/settings/utils/useSettingValue';
import EventGridComplete from 'common/components/EventGridComplete';
import { UserPermissions } from 'common/features/userPermissions/PermissionsEnum';
import { useUserPermissions } from 'common/features/userPermissions/useUserPermissions';
import useFlexBoxStyles from 'common/flexBox';
import LayoutSectionHeader from 'common/layouts/LayoutSectionHeader';
import SkeletonEventItem from 'common/layouts/skeleton/SkeletonEventItem';
import { range } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBatchCapacitiesAction, getServicesTotal } from 'redux/slices/serviceSlice';
import { getTemplateTypes } from 'redux/slices/templateTypeSlice';
import { makeStyles } from 'tss-react/mui';
import { getUser } from '../../redux/slices/authSlice';
import { getCapacities } from '../../redux/slices/serviceSlice';
import ServiceCard from './ServiceItem';
import ServicesFilter from './filters/ServicesFilter';

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            minWidth: theme.spacing(33),
            maxWidth: theme.spacing(45),
            flexBasis: theme.spacing(30),
        },
    };
});

const ServicesList = ({ templates, isService, groups, pending, userView, type }) => {
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const templateTypes = useSelector(getTemplateTypes);
    const total = useSelector(getServicesTotal);
    const capacities = useSelector(getCapacities);
    const showServiceCapacity = useSettingValue(SettingsKey.SHOW_SERVICE_CAPACITY);
    const permissions = useUserPermissions({ permission: UserPermissions.SERVICE });

    useEffect(() => {
        if (templates?.length > 0 && showServiceCapacity) {
            const templateIds = templates.map((t) => t.id);
            dispatch(fetchBatchCapacitiesAction({ templateIds }));
        }
    }, [templates, dispatch, showServiceCapacity]);

    return (
        <LayoutSectionHeader
            total={total}
            filters={{
                showSearch: !userView,
                showDateFilter: true,
                showDateIntervals: type === 'past',
                useEndDateMaxDate: type === 'past',
                customFilters: isService ? <ServicesFilter /> : null,
            }}
        >
            <Stack
                direction="row"
                className={cx(flexBox.wrap, flexBox.w100, flexBox.h100, flexBox.overflowXHidden, flexBox.scrollbarNone)}
            >
                {templates?.map((item, idx) => {
                    const type = templateTypes.find((t) => t.id === item.typeId);
                    const group = groups.find((g) => g.id === item.userGroupId);
                    const disabledDelete = user?.userGroupId !== null && item.taxonomy !== null;
                    return (
                        <React.Fragment key={idx}>
                            <Stack className={cx(flexBox.grow1, flexBox.padding3, flexBox.borderBox, classes.root)}>
                                <ServiceCard
                                    permissions={permissions}
                                    type={type}
                                    group={group}
                                    disabledDelete={disabledDelete}
                                    template={item}
                                    isService={isService}
                                    capacity={showServiceCapacity ? capacities?.[item.id] : null}
                                />
                            </Stack>
                        </React.Fragment>
                    );
                })}
                {pending &&
                    range(1, 13, 1).map((i) => {
                        return (
                            <React.Fragment key={i}>
                                <SkeletonEventItem />
                            </React.Fragment>
                        );
                    })}
                <EventGridComplete />
            </Stack>
        </LayoutSectionHeader>
    );
};

export default ServicesList;
